import { render, staticRenderFns } from "./ViewMessage.vue?vue&type=template&id=4c0fb0a0"
import script from "./ViewMessage.vue?vue&type=script&lang=js"
export * from "./ViewMessage.vue?vue&type=script&lang=js"
import style0 from "./ViewMessage.vue?vue&type=style&index=0&id=4c0fb0a0&prod&lang=css"
import style1 from "./ViewMessage.vue?vue&type=style&index=1&id=4c0fb0a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports